import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import restaurantImg from "./../../../assets/icons/cafe.png";
import dekiveryImg from "./../../../assets/icons/delivery-man.png";
import "./LoginSelectionDialog.css";
import jwtDecode from "jwt-decode";
const LoginSelectionDialog = (props) => {
  const handleClose = (reason) => {
    if (reason && reason == "backdropClick") return;
    props.onHandleAddItem(false);
  };

  const checkCourierId = () => {
    var decoded = {};
    const token = localStorage.getItem("gotasteadmintoken");

    if (token != null) {
      try {
        decoded = jwtDecode(token);
        console.log(decoded);
      } catch (error) {
        console.log(error);
      }
    }
    if (decoded.courierId == "CourierNotFound" || decoded.courierId == "") {
      window.location.href = "/courier-registration";
    } else {
      window.location.href = "/courier-dashboard";
    }
  };
  return (
    <Dialog className="" maxWidth="sm" open={props.open} onClose={handleClose}>
      <DialogContent>
        <div
          className="d-flex justify-content-center align-items-center "
          style={{ gap: "20px" }}
        >
          <div
            className="d-flex justify-content-center align-items-center loginselectionCard"
            style={{ flexDirection: "column", cursor: "pointer" }}
            onClick={() => {
              window.location.href = "/";
            }}
          >
            <div>
              <img src={restaurantImg} alt="" style={{ width: "5rem" }} />
            </div>
            <span>
              <b>Login as restaurant</b>
            </span>
          </div>
          <div
            className="d-flex justify-content-center align-items-center loginselectionCard"
            style={{ flexDirection: "column", cursor: "pointer" }}
            onClick={() => {
              checkCourierId();
            }}
          >
            <div>
              <img src={dekiveryImg} alt="" style={{ width: "5rem" }} />
            </div>
            <span>
              <b>Login as courier</b>
            </span>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LoginSelectionDialog;
